module.exports = __webpack_public_path__ + "static/media/Card_PP.04fed250.svg";